import { Controller, useFormContext } from 'react-hook-form';
import { Input, Radio, RadioGroup } from '@ds';
import { FormSection } from '@features/components/CaseFormBlocks/components';
import { BloodGroupAbo } from '@/api/apis/case';
import { DonorFormRow } from './DonorFormRow';
import { DonorProfileFormValues } from '../types';

const ABO_OPTIONS = [
  { value: BloodGroupAbo.A, label: 'A' },
  { value: BloodGroupAbo.B, label: 'B' },
  { value: BloodGroupAbo.AB, label: 'AB' },
  { value: BloodGroupAbo.O, label: 'O' },
] as const;

export const BloodSection = () => {
  const { control } = useFormContext<DonorProfileFormValues>();

  return (
    <FormSection title="Blood">
      <DonorFormRow title="ABO">
        <Controller
          name="aboType"
          control={control}
          render={({ field: { value, onChange, ...field }, fieldState: { invalid, error } }) => (
            <RadioGroup
              orientation="horizontal"
              value={value ?? ''}
              isInvalid={invalid}
              errorMessage={error?.message}
              onValueChange={onChange}
              {...field}
            >
              {ABO_OPTIONS.map((opt) => (
                <Radio
                  key={opt.value}
                  className="w-[100px] max-w-none"
                  classNames={{ label: 'pl-1' }}
                  value={opt.value}
                  size="lg"
                >
                  {opt.label}
                </Radio>
              ))}
            </RadioGroup>
          )}
        />
      </DonorFormRow>

      <DonorFormRow title="Positive Serologies">
        <div className="flex-1">
          <Controller
            name="positiveSerologies"
            control={control}
            render={({ field, fieldState: { invalid, error } }) => (
              <Input
                placeholder="Enter value"
                aria-label="Positive serologies"
                isInvalid={invalid}
                errorMessage={error?.message}
                {...field}
                value={field.value ?? ''}
              />
            )}
          />
        </div>
      </DonorFormRow>
    </FormSection>
  );
};
